import Facilities from "./Facilities";

export const menuItemsData = [
    {
        id: 1,
        title: "User",
        path: "/bkoff/User",
        cName: "nav-item",   
      },
      {
        id: 2,
        title: "Department",
        cName: "nav-item", 
        submenu: [
          {
            id: 21,
            title: "Department Master",
            path: '/bkoff/Department',
            cName: "nav-item", 
          },
          {
            id: 22,
            title: "Treatment under Dept",
            path: '/bkoff/Treatments',
            cName: "nav-item", 
          },
          {
            id: 23,
            title: "Facilities",
            path: '/bkoff/Facilities',
            cName: "nav-item", 
          },
          {
            id: 24,
            title: "Testimonials",
            path: '/bkoff/DeptTestimonials',
            cName: "nav-item", 
          },
          {
            id: 25,
            title: "FAQ",
            path: '/bkoff/DeptFAQ',
            cName: "nav-item", 
          },
        ]
      },
      {
        id: 3,
        title: "Speciality",
        cName: "nav-item",
        submenu: [
          {
            id: 31,
            title: "Specialities",
            path: '/bkoff/Speciality',
            cName: "nav-item",
          },
          {
            id: 32,
            title: "Disease",
            path: '/bkoff/Disease',
            cName: "nav-item",
          },
          {
            id: 33,
            title: "Testimonials",
            path: '/bkoff/Testimonials',
            cName: "nav-item",
          },
          {
            id: 34,
            title: "FAQ",
            path: '/bkoff/FAQ',
            cName: "submenu-item",
          },       
        ]
      },
  
      {
        id: 4,
        title: "Diagonestic Service",
        cName: "nav-item",
        submenu: [
          {
            id: 41,
            title: "Diagnostics Master",
            path: '/bkoff/Diagnosis',
            cName: "nav-item", 
          },
          {
            id: 42,
            title: "Services",
            path: '/bkoff/DiagService',
            cName: "nav-item", 
          },
          {
            id: 43,
            title: "Why choose us",
            path: '/bkoff/WhyChooseUs',
            cName: "nav-item", 
          },
          {
            id: 44,
            title: "Testimonials",
            path: '/bkoff/DiagTestimonials',
            cName: "nav-item", 
          },
          {
            id: 45,
            title: "FAQ",
            path: '/bkoff/DiagFAQ',
            cName: "nav-item", 
          },
        ]    
      },
    
      {
        id: 5,
        title: "Doctors",
        cName: "nav-item",
        submenu: [
          {
            id: 51,
            title: "Doctor-Master",
            path: "/bkoff/Doctors",
            cName: "submenu-item",
          },
          {
            id: 52,
            title: "Doctors-Schedule",
            path: '/bkoff/Scheduler',
            cName: "submenu-item",
          }, 
        ],
      },
      {
        id: 6,
        title: "SEO Tags",
        path: '/bkoff/Seotags',
        cName: "nav-item",
      },
      {
        id: 7,
        title: "Visitor",
        cName: "nav-item",
        submenu: [
          {
            id: 71,
            title: "Visitor-Management",
            path: '/bkoff/Visitors',
            cName: "submenu-item",
          },
          {
            id: 72,
            title: "Appointment",
            path: '/bkoff/Appointments',
            cName: "submenu-item",
          },   
          {
            id: 73,
            title: "Health Card-Org",
            path: '/bkoff/HealthCard',
            cName: "submenu-item",
          }, 
          {
            id: 73,
            title: "Health Card-Applicant",
            path: '/bkoff/HealthcardUser',
            cName: "submenu-item",
          }, 
        ],
      },
      {
        id: 10,
        title: "Logout",
        path: '/bkoff/Logout',
        cName: "nav-item",
      },
{/*      
      {
        id: 11,
        title: "Dummy",
        path: '/bkoff/Dummy',
        cName: "nav-item",
      },
*/}
    ];


